import React, { FunctionComponent, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import RoleIcon from "@material-ui/icons/AccountBox";
import ListItemText from "@material-ui/core/ListItemText";
import Plus from "@material-ui/icons/Add";
import Minus from "@material-ui/icons/Remove";
import CheckboxTree from "react-checkbox-tree";
import "./style.css";
import { useRoleStyles } from "../useRoleStyles";
import { useStore } from "../../../store";
import { api } from "../../../api";

import { SnackBar } from "../../SnackBar";

type PermissionProps = {
  role_id: number;
  permissionDetails: Array<any>;
  expandedData: Array<any>;
  changeToRoles: () => void;
  goBackToList: () => void;
  permissionFlag: boolean;
  handlePermissionFlag: () => void;
  roles: any;
  addRolePermission:boolean;
};

export const RolePermissions: FunctionComponent<PermissionProps> = ({
  role_id,
  permissionDetails,
  expandedData,
  changeToRoles,
  goBackToList,
  permissionFlag,
  handlePermissionFlag,
  roles,
  addRolePermission
}) => {
  const classes = useRoleStyles();

  const [user] = useStore("auth", "user");
  const [permissions, { editPermission, addPermission }] = useStore("permissions");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [permissionStatus, setPermissionStatus] = useState<string>("");
  const [roleId, setRoleId] = useState<number>(role_id);
  const [expanded, setExpanded] = useState<any>(expandedData);
  const [checked, setChecked] = useState<any>(permissionDetails);
  const [arrayExpanded, setArrayExpanded] = useState<any>();
  const [createOrEditFlag, setCreateOrEditFlag] = useState<boolean>(false);

  const filteredRoles= roles.filter((i:any)=>!user.roles.some((j: any) => j === i.id))

  const data =
    permissions &&
    permissions.map((i: any) => ({
      value: i.id,
      label: i.description,
      children: 
      i.id===1 || i.id===10 || i.id===12 || i.id===17 || i.id===18 || i.id===19?[
        { value: i.id + ":is_view", label: "View" }
      ]: 
      i.id===3 || i.id===2?[
        { value: i.id + ":is_view", label: "View" },
        { value: i.id + ":is_add", label: "Add" },
      ]:
      i.id===6 || i.id===11 || i.id===15 || i.id===16?[
        { value: i.id + ":is_view", label: "View" },
        { value: i.id + ":is_edit", label: "Edit" }
      ]:
      [
        { value: i.id + ":is_view", label: "View" },
        { value: i.id + ":is_add", label: "Add" },
        { value: i.id + ":is_edit", label: "Edit" },
        // { value: i.id + ":is_delete", label: "Delete" },
      ],
    }));

  const selectRole = async (roleid: number) => {
    try {
      setChecked(undefined);
      setExpanded(undefined);
      setRoleId(roleid);
      handlePermissionFlag();
      const result = await api.get(`roles/${roleid}/permissions`);
      const expandedArray: Array<any> = [];
      const arr: Array<any> = [];
      result &&
        result.map((i: any) =>
          i.is_add === true ? arr.push(i.permission_id + ":is_add") : null
        );
      result &&
        result.map((i: any) =>
          i.is_edit === true ? arr.push(i.permission_id + ":is_edit") : null
        );
      result &&
        result.map((i: any) =>
          i.is_view === true ? arr.push(i.permission_id + ":is_view") : null
        );
      result &&
        result.map((i: any) =>
          i.is_delete === true ? arr.push(i.permission_id + ":is_delete") : null
        );
      result && result.map((i: any) => expandedArray.push(i.permission_id));
      setChecked(arr);
      setExpanded(expandedArray);
      setArrayExpanded(expandedArray);
    } catch (error) {
      console.log(error);
      setCreateOrEditFlag(true);
      handlePermissionFlag();
    }
  };

  const savePermission = async () => {
    try {
      const list =
        permissions &&
        permissions.map((role: any) => {
          const roleStr = role.id + ":";
          const rolePerms = checked.filter((x: any) =>
            x.startsWith(roleStr, 0)
          );
          const selectedPermissions = rolePerms.map((x: any) => {
            const names = x.split(":");
            return names[1];
          });
          let isAdd = false,
            isView = false,
            isEdit = false,
            isDelete = false;
          if (selectedPermissions.includes("is_add")) {
            isAdd = true;
          }
          if (selectedPermissions.includes("is_view")) {
            isView = true;
          }
          if (selectedPermissions.includes("is_edit")) {
            isEdit = true;
          }
          if (selectedPermissions.includes("is_delete")) {
            isDelete = true;
          }
          const obj = {
            permission_id: role.id,
            is_add: isAdd,
            is_view: isView,
            is_edit: isEdit,
            is_delete: isDelete,
          };
          return obj;
        });

      const arr: (string | any[])[] = [];
      checked.map((i: any) => arr.push(i.split(":")[0]));

      const checkedData = arr.filter(
        (value: any, index: any) => arr.indexOf(value) === index
      );

      const values =
        list &&
        list.filter(
          (i: any) =>
            checkedData && checkedData.some((j: any) => j == i.permission_id)
        );

      if (arrayExpanded === undefined) {
        setCreateOrEditFlag(true);
      } else {
        setCreateOrEditFlag(false);
      }

      if (createOrEditFlag === true) {
        const res = await addPermission(values, roleId);

        if (res !== undefined) {
          setSnackbarColor("green");
          setPermissionStatus("Permission successfully added");
          setCreateOrEditFlag(false);
          setArrayExpanded([]);
          setTimeout(() => {
            goBackToList();
          }, 2000);
        }
      } else {
        const res = await editPermission(values, roleId);

        if (res !== undefined) {
          setSnackbarColor("green");
          setPermissionStatus("Permission successfully edited");
          setCreateOrEditFlag(false);
          setArrayExpanded([]);
          setTimeout(() => {
            goBackToList();
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
      setSnackbarColor("red");
      setPermissionStatus("Something went wrong");
      setCreateOrEditFlag(false);
      setArrayExpanded([]);
    }
  };

  const onCloseSnackbar = () => {
    setPermissionStatus("");
  };

  const handleCheck = (checkedItems: any) => {
    handlePermissionFlag();
    setChecked(checkedItems);
    checkedItems.map((i: any) => {
      if ((i.split(":")[1] === "is_edit") || (i.split(":")[1] === "is_delete")) {
        const value = i.split(":")[0] + ":" + "is_view"
        if (checkedItems.includes(value) === false) {
          checkedItems.push(value);
        }
      }
    })
    const arr: (string | any[])[] = [];
    checkedItems.map((i: any) => arr.push(i.split(":")[0]));
    setExpanded(
      arr.filter((value: any, index: any) => arr.indexOf(value) === index)
    );
  };

  if(roles.length===0){
    return(
      <div style={{marginTop:"2em",marginBottom:"2em"}}>
        <Typography variant="h5">
          With your existing role priority, you are not permitted to view or add permissions for any role !
        </Typography>
      </div>
    )
  }else{

  return (
    <Grid container>
      <SnackBar
        status={permissionStatus}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />

      <Grid item xs={12} sm={6} className={classes.rolePermissionHeading}>
        <div className={classes.divStyle}>
          <Grid container>
            <Grid item>
              <Typography className={classes.permissionHeading}>
                Roles
              </Typography>
            </Grid>
            <Grid item className={classes.buttonGridStyle} style={{display: addRolePermission?"":"none"}}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                onClick={() => changeToRoles()}
              >
                Add
              </Button>
            </Grid>
          </Grid>

          <div className={classes.divStyle}>
            <List component="nav">
              {filteredRoles &&
                filteredRoles.map((i: any) => (
                  <ListItem
                    className={classes.listItemStyle}
                    id="listbckgrnd"
                    selected={roleId === i.id}
                    onClick={() => selectRole(i.id)}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <RoleIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      className={classes.listItemTextStyle}
                      primary={i.name}
                    />
                  </ListItem>
                ))}
            </List>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} sm={6} className={classes.rolePermissionHeading}>
        <div className={classes.divStyle}>
          <Grid container>
            <Grid item>
              <Typography className={classes.permissionHeading}>
                Permissions
              </Typography>
            </Grid>
            <Grid item xs={8} className={classes.buttonGridStyle}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                disabled={checked === undefined}
                onClick={() => savePermission()}
              >
                Save
              </Button>
            </Grid>
          </Grid>
          <div className={classes.checkBoxStyle} style={{
            height: "40em",
            overflow: "auto",
            marginTop: '10px'
          }}>
            <CheckboxTree
              icons={{
                expandClose: <Plus className={classes.iconStyle} />,
                expandOpen: <Minus className={classes.iconStyle} />,
              }}
              // showCheckBox={true}
              nodes={data}
              checked={permissionFlag === true ? permissionDetails : checked}
              expanded={permissionFlag === true ? expandedData : expanded}
              onCheck={(checkedItems) => handleCheck(checkedItems)}
              onExpand={(expandedNodes) => {
                handlePermissionFlag();
                setExpanded(expandedNodes)
              }}
            // style={{ marginTop: "0.4em", color: "#0077C8" }}
            />
          </div>
        </div>
      </Grid>
    </Grid>
  )
 }
};